// extracted by mini-css-extract-plugin
module.exports = {"App":"App__App__1o-Fp","App-logo":"App__App-logo__3JCPt","App-logo-spin":"App__App-logo-spin__RvI1J","App-header":"App__App-header__3iH8L","App-link":"App__App-link__13fTZ"};